import React, { useEffect, useState } from 'react';

import {
  Box,
  Grid,
  IconButton,
  TextField,
  FormControl,
  FormHelperText,
  Divider,
  Select,
  MenuItem,
} from '@mui/material';
import 'dayjs/locale/ko'; 
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; 
import DateAdapter from '@mui/lab/AdapterDateFns';
import * as dayjs from 'dayjs'

import { useFormikContext, getIn } from 'formik';

import DeleteIcon from '@mui/icons-material/Delete';
import MultiUploadComponent from '../../common/form/MultiUploadComponent';

const ProjectMultiFileForm = ({
  file,
  sellPartnerOptions,
  index,
  touched,
  errors,
  handleRemove,
  handleChange,
  handleBlur,
}) => {
  const formikProps = useFormikContext();

  const sellPartnerUuid = `files[${index}].sellPartnerUuid`;
  const touchedSellPartnerUuid = getIn(touched, sellPartnerUuid);
  const errorSellPartnerUuid = getIn(errors, sellPartnerUuid);

  const fileAttrVal5 = `files[${index}].fileAttrVal5`;
  const touchedFileAttrVal5 = getIn(touched, fileAttrVal5);
  const errorFileAttrVal5 = getIn(errors, fileAttrVal5);

  // useEffect(() => {
  //   console.log(index, formikProps.values?.files?.[index]?.fileAttrVal5);
  // }, [formikProps.values.files, index]);

  const fileVal = `files[${index}].file`;
  const touchedFile = getIn(touched, fileVal);
  const errorFile = getIn(errors, fileVal);

  const fileDesc = `files[${index}].fileDesc`;
  const touchedFileDesc = getIn(touched, fileDesc);
  const errorFileDesc = getIn(errors, fileDesc);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          marginTop: 2,
          px: 2,
        }}
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={3}>
            <FormControl
              fullWidth
              error={touchedSellPartnerUuid && Boolean(errorSellPartnerUuid)}
            >
              <Select
                inputProps={{ 'aria-label': '매출처' }}
                value={formikProps.values.files[index].sellPartnerUuid}
                onChange={(event, newValue) => {
                  formikProps.setFieldValue(
                    sellPartnerUuid,
                    event.target.value,
                  );
                }}
                displayEmpty
              >
                <MenuItem value="">
                  <em>매입처를 선택하세요</em>
                </MenuItem>
                {sellPartnerOptions &&
                  sellPartnerOptions.length > 0 &&
                  sellPartnerOptions.map((option) => (
                    <MenuItem
                      key={option.sellPartnerUuid}
                      value={option.sellPartnerUuid}
                    >
                      {option.sellPartnerNm}
                    </MenuItem>
                  ))}
              </Select>
              <FormHelperText>
                {touchedSellPartnerUuid && errorSellPartnerUuid}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
              <DatePicker
                label="받은(수신)날짜"
                format="YYYY-MM-DD"
                mask={'____-__-__'}
                id={fileAttrVal5}
                name={fileAttrVal5}
                value={dayjs(formikProps.values.files[index].fileAttrVal5)}
                onChange={(newValue) => {
                  formikProps.setFieldValue(fileAttrVal5, dayjs(newValue));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    fullWidth
                    error={Boolean(touchedFileAttrVal5 && errorFileAttrVal5)}
                    helperText={
                      touchedFileAttrVal5 && errorFileAttrVal5
                        ? errorFileAttrVal5
                        : ''
                    }
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={3}>
            <MultiUploadComponent index={index} formik={formikProps} />
            {touchedFile && Boolean(errorFile) && (
              <FormControl error>
                <FormHelperText>{touchedFile && errorFile}</FormHelperText>
              </FormControl>
            )}
          </Grid>

          <Grid item xs={3}>
            <TextField
              variant="standard"
              fullWidth
              name={fileDesc}
              id={fileDesc}
              value={formikProps.values.files[index].fileDesc}
              helperText={touchedFileDesc && errorFileDesc ? errorFileDesc : ''}
              error={Boolean(touchedFileDesc && errorFileDesc)}
              onChange={handleChange}
              onBlur={handleBlur}
              label="비고"
            />
          </Grid>
          <Grid item xs={1}>
            <IconButton aria-label="delete" onClick={handleRemove}>
              <DeleteIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Box>
      <Divider sx={{ my: 1 }} />
    </>
  );
};

export default ProjectMultiFileForm;
